import apiClient from "./client";

export const loginRequest = async (credentials) => {
  const response = await apiClient.post("/auth/login", credentials);
  return response.data;
};

export const fetchCurrentUser = async () => {
  const response = await apiClient.get("/auth/me");
  return response.data;
};

export const requestPasswordReset = async (payload) => {
  const response = await apiClient.post("/auth/request-password-reset", payload);
  return response.data;
};

export const confirmPasswordReset = async (payload) => {
  const response = await apiClient.post("/auth/reset-password", payload);
  return response.data;
};

export const verifyEmailLink = async (payload) => {
  const response = await apiClient.post("/auth/verify-email-link", payload);
  return response.data;
};